import { render, staticRenderFns } from "./childFatList.vue?vue&type=template&id=539432a8&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./childFatList.vue?vue&type=script&lang=js&"
export * from "./childFatList.vue?vue&type=script&lang=js&"
import style0 from "./childFatList.vue?vue&type=style&index=0&id=539432a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539432a8",
  null
  
)

export default component.exports